import React from "react"

export default function GradientBackground() {
  return (
    <div className='gradient-wrapper'>
      <div className='gradient-bg'></div>
    </div>
  )
}
